import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { GetGuidService } from './get-guid.service';
import { AuthToken, DWDPATSessionModel, sessionResponse } from '../../models/session.model';
import { DWWalletSetup } from '../../models/DWWalletSetup.interface';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { PayinTokens } from '../../models/payintokens.model';

@Injectable({
  providedIn: 'root'
})
export class WalletSetupService {

    private walletSetupUrl = ApiEndpoints.walletSetup;
    httpOptions:any;
    constructor(private http: HttpClient, private getheader: GetGuidService) {
  }

// --- LEGACY METHODS (PPI/ONL) ---  
  updateWalletSetup(data:any): any {
    let token=sessionStorage.getItem("headers");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        "Authorization": "bearer " + token
      }),
    };
    const url = `${this.walletSetupUrl}`;
    return this.http.post<any>(url, data, httpOptions);
}

  setNotificationPreferences(data: any): Observable<any> {
    const url = `${this.walletSetupUrl}/dwsetnotificationpreferences`;
    return this.http.post<any>(url, data);
  }

  // Import the new endpoint
// updateWalletSetupNextGen(data: any): Observable<any> {
//     // 1. Get the correct token (Next Gen uses 'walletheaders')
//     // Fallback to 'headers' if 'walletheaders' is missing
//     const token = sessionStorage.getItem("walletheaders") || sessionStorage.getItem("headers");

//     const httpOptions = {
//       headers: new HttpHeaders({
//         "Content-Type": "application/json",
//         "Authorization": "Bearer " + token
//       }),
//     };

//     // 2. Use the NEW Azure URL defined in ApiEndpoints
//     const url = ApiEndpoints.walletSetupNextGen;
//     console.log('🔗 Calling Next Gen Setup API:', url); 

//     return this.http.post<any>(url, data, httpOptions);
//   }

updateWalletSetupNextGen(data: any): Observable<any> {
    // 1. Get the token and provide a fallback empty string
    const rawToken = sessionStorage.getItem("walletheaders") || sessionStorage.getItem("headers") || '';
    
    // 2. CRITICAL: Strip out any accidental JSON quotes!
    const cleanToken = rawToken.replace(/"/g, '');

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": "Bearer " + cleanToken // Use the clean token
      }),
    };

    const url = ApiEndpoints.walletSetupNextGen;
    console.log('🔗 Calling Next Gen Setup API:', url); 

    return this.http.post<any>(url, data, httpOptions);
}

updateWalletStatus(walletID: string, sessionID: string, newStatus: string): Observable<any> {
    // 1. Get the token
    const token = sessionStorage.getItem("walletheaders") || sessionStorage.getItem("headers");

    // 2. Set Headers and Query Parameters
    const httpOptions = {
      headers: new HttpHeaders({
        "accept": "text/plain", // Matches the curl header
        "Authorization": "Bearer " + token
      }),
      // Use HttpParams to safely append ?WalletID=...&sessionID=...&NewStatus=... to the URL
      params: new HttpParams()
        .set('WalletID', walletID)
        .set('sessionID', sessionID)
        .set('NewStatus', newStatus)
    };

    const url = ApiEndpoints.dwUpdateWalletStatus;
    
    console.log('🔗 Calling Update Wallet Status API:', url); 

    // 3. Make the POST request. The body is an empty object {} because the data is in the URL parameters.
    return this.http.post<any>(url, {}, httpOptions);
  }

}
